<!--
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-08-07 14:04:02
 * @LastEditors: knx-xc
--> 
<template>
  <div class="dy-body">
    <!-- 动态  animated  -->
    <PageTitle class=" fadeInUp"></PageTitle>
    <div class="content container-body  fadeInUp">
      <Bread :breads="[{name:'动态',path:''}]"></Bread>
      <ul class="article-list ">
        <li v-for="(item,index) of list" :key="index">
          <div class="image" v-if="item.indexImg">
            <img :src="item.indexImg" alt="">
          </div>
          <div class="info">
            <div class="title-box">
              <el-tag v-if="item.isTop" size="small " type="danger" effect="dark">置顶</el-tag>
              <h4 v-text="item.title"></h4>
            </div>
            <div class="subtitle-box">
              <p class="subtitle" v-text="item.briefIntroduction"></p>
              <p class="show-more"> <span class="more" v-text="'查看全文'" @click="showDeail({index:index})"> </span></p>
            </div>
          </div>
        </li>
      </ul>
      <div class="pagination" v-show="params.totalCount > params.limit">
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[20,30,40,50]" :page-size="params.limit" layout="total, sizes, prev, pager, next" :total="params.totalCount">
        </el-pagination>
      </div>
    </div>

    <!-- 详情 -->
    <!-- <div class="article-detail" v-show="!showList">
      <detail v-if="!showList" :detail="detail">
        <Bread :breads="breads"></Bread>
      </detail>
    </div> -->
  </div>
</template>
 
<script>
import PageTitle from '@/components/user/PageTitle';
import { article_list, } from "@/request/api.user/all";
export default {
  name: '',
  components: { PageTitle },
  data() {
    return {
      breads: [
        { name: '动态', path: 'dynamic' },
        { name: '', path: '' },
      ],
      params: {
        page: 1,
        limit: 20,
        totalCount: 0,
      },
      list: [],
    }
  },
  created() {
    this.getArticleList();
  },
  mounted() {

  },
  methods: {
    // 查看文章详情
    showDeail({ index }) {
      sessionStorage.setItem('art_id',this.list[index]['id'] );
      this.$router.push({
        path: 'articles',
        // query: { id: this.list[index]['id'] }
      })
    },

    // 获取动态新闻列表
    getArticleList() {
      article_list().then(res => {
        // console.log(res)
        if (res.code !== 0) return
        this.list = res['page']['list'];
        this.params['page'] = res['page']['currPage'];
        this.params['limit'] = res['page']['pageSize'];
        this.params['totalCount'] = res['page']['totalCount'];
      })
    },
    handleSizeChange(size) {
      this.params.limit = size;
      this.params.page = 1;
      this.getDynamicList();
    },

    handleCurrentChange(page) {
      this.params.page = page;
      this.getDynamicList();
    },
  }
}
</script>
 
<style  lang="less" rel="stylesheet/less"  scoped>

.dy-body {
  width: 100%;
  height: 100%;
  background: #fafafa;
  & > .content {
    .article-list {
      // background: #ffffff;
      // padding: 0 200px;
      text-align: left;
      li {
        display: flex;
        align-items: center;
        padding: 20px;
        .image {
          width: 240px;
          height: 170px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          margin-left: 20px;
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 170px;

          h4 {
            font-size: 20px;
            color: #333333;
            padding: 30px 10px;
          }
          div.title-box {
            display: flex;
            align-items: center;
          }
          div.subtitle-box {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
          p.subtitle {
            flex: 1;
            width: 100%;
            font-size: 16px;
            color: #666666;
            line-height: 32px;
            display: inline-block;
            overflow: hidden;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
          }
          p.show-more {
            width: 100%;
            text-align: right;
          }
          span.more {
            color: #1c84d4;
            font-size: 16px;
            cursor: pointer;
          }
          span.more:hover {
            font-size: 18px;
          }
        }
        li:not(:last-child){
          margin-bottom: 40px;
        }
        li::hover{
          cursor: pointer;
          background: #f5f5f5;
        }
      }
      li:hover{
        cursor: pointer;
        // background: #ffffff;
        background: #f5f5f5;
      }
    }
    .pagination {
      padding: 20px;
    }
  }
  .article-detail {
    .bread {
      padding: 40px 200px;
      display: flex;
      color: #666666;
      font-size: 14px;
      .position {
        margin-right: 10px;
      }
      img {
        margin-right: 6px;
      }
      .pointer {
        display: inline-block;
        padding: 0 5px;
        cursor: pointer;
      }
      .pointer:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>